// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatNotificationDisplayDashboardToggleForDisplayText {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    max-width: 20em;
}

.chatNotificationDisplayLineDashboard {
    border: 1px solid var(--GrayBlue);
}

.chatNotificationDisplayLoading {
    display: flex;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Settings/SettingsContent/chatNotificationDisplay/chatNotificationDisplay.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":[".chatNotificationDisplayDashboardToggleForDisplayText {\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n    max-width: 20em;\n}\n\n.chatNotificationDisplayLineDashboard {\n    border: 1px solid var(--GrayBlue);\n}\n\n.chatNotificationDisplayLoading {\n    display: flex;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
